<div class="lightTheme">
    <div *ngIf="isLoading" class="svg-loader"></div>
    <div class="d-flex flex-row page-header">
        Notification Subscription
      <button (click)="createNotification()" matTooltip="Add" matTooltipPosition="right" class="btn actionBtn add p-0"></button>
    </div>
    <div class="d-flex search_filter_area">
      <div class="d-inline-block" id="searchBar">
        <input class="form-control" type="text" (keyup)="globalService.applyFilter($event.target.value, notificationListDetails); setSearchText($event.target.value);" placeholder="Search" [(value)]="searchText">
        <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
      </div>
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
        <mat-chip-listbox #chipList>
          <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
            {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
            <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
      <div class="tbl_head_action float-right">
        <span class="filterIcon" matTooltip="Add Filter" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth"></span>
        <span class="exportIcon ml-2" matTooltip="Export to Excel" (click)="exporterNotifications.exportTable('xlsx', {fileName:'NotificationSubscriptions', sheet: 'Notification Subscriptions'})"></span>
      </div>
    </div>
    <div class="d-flex flex-column notificationTable">
      <mat-table matTableExporter [dataSource]="notificationListDetails" matSort matSortActive="tenantRefinery​​" matSortDirection="asc" #exporterNotifications="matTableExporter" hiddenColumns="[5]">
        <ng-container matColumnDef="subscriptionId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Subscription Id </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.subscriptionId}} </mat-cell>
        </ng-container> 
        <ng-container matColumnDef="tenantName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Tenant </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.tenantName}} </mat-cell>
        </ng-container>        
        <ng-container matColumnDef="tenantId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Tenant Id</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.tenantId}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="categoryName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Notification Category</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.categoryName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="subscribedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Subscribed By </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.subscribedBy}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="subscribedDateTime">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Subscribed Date and Time </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.subscribedDateTime | date: 'yyyy-MM-dd T HH:mm:ss'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="mat-column-action1"><span class="ml4">Action</span></mat-header-cell>
          <mat-cell class="tbl_action" *matCellDef="let element; let i = index;">
            <button class="actionIcon pointer" matTooltip="View" mat-icon-button (click)="openDialog('view', element)">
              <mat-icon class="action-icon-view"></mat-icon>
            </button>
            <button class="actionIcon pointer" matTooltip="Edit" mat-icon-button (click)="openDialog('edit', element)">
              <mat-icon class="action-icon-edit"></mat-icon>
            </button>
            <button class="actionIcon pointer" (click)="deleteNotification(element)" matTooltip="Delete" mat-icon-button>
              <mat-icon class="action-icon-delete"></mat-icon>
            </button>
           
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <div *ngIf="(notificationListDetails.data.length === 0) && (!isLoading)" class="emptyRepoMsg">
        <span> There are no records to display.</span>
      </div>
      <mat-paginator [hidden]="!notificationListDetails.data.length" #paginator [pageSizeOptions]="[10,20,30,50]" [pageSize]="10">
      </mat-paginator>
    </div>
    <div class="clearfix"></div>
    <ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
  </div>
  